import styled from '@emotion/styled'

export const Wrapper = styled.div`
  max-width: 320px;
  padding: 12px 20px 0;
`
